import { put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import { getGallectionDeviationStreamId } from '../helpers';
import {
  getCurrentMediaSource,
  getCurrentFolderId,
  getSearchQuery,
  getCurrentSubfolderId,
} from '../selectors';

export default function* (): SagaIterator {
  const {
    mediaSource,
    folderId,
    subfolderId,
    searchQuery,
  }: {
    mediaSource: ReturnType<typeof getCurrentMediaSource>;
    folderId: ReturnType<typeof getCurrentFolderId>;
    subfolderId: ReturnType<typeof getCurrentSubfolderId>;
    searchQuery: ReturnType<typeof getSearchQuery>;
  } = yield select(state => ({
    mediaSource: getCurrentMediaSource(state),
    folderId: getCurrentFolderId(state),
    subfolderId: getCurrentSubfolderId(state),
    searchQuery: getSearchQuery(state),
  }));
  const streamId = getGallectionDeviationStreamId(
    mediaSource,
    subfolderId || folderId,
    searchQuery
  );

  const isFetching: ReturnType<typeof selectors.isFetching> = yield select(
    selectors.isFetching,
    streamId
  );
  if (isFetching) {
    return;
  }

  yield put(withOffset.actions.fetch(streamId));
}
